module.exports = __webpack_public_path__ + "static/DSCF3950.da2e57d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/DSCF3950.jpg
// module id = 493
// module chunks = 114276838955818